"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK = exports.getFactory = exports.factory = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
require("isomorphic-fetch");
var gooddata_1 = require("./gooddata");
Object.defineProperty(exports, "SDK", { enumerable: true, get: function () { return gooddata_1.SDK; } });
var getFactoryBrowser = function (config) { return gooddata_1.factory(fetch.bind(window))(config); };
exports.getFactory = getFactoryBrowser;
/**
 * @deprecated use getFactory instead
 */
var factoryBrowser = gooddata_1.factory(fetch.bind(window));
exports.factory = factoryBrowser;
tslib_1.__exportStar(require("./api"), exports);
exports.default = factoryBrowser();
//# sourceMappingURL=gooddata-browser.js.map